import { forwardRef } from 'react'
import { StyledLoading } from './styles'
import RRLoading from './assets/raskrask-loading.json'
import { LoadingProps } from './props'
import { Player } from '@lottiefiles/react-lottie-player'

const Loading = forwardRef<Player, LoadingProps>(
    ({ autoplay = true, loop = true, src = RRLoading, ...props }, ref) => (
        <StyledLoading
            {...props}
            autoplay={autoplay}
            loop={loop}
            ref={ref}
            src={src}
        />
    )
)

Loading.displayName = 'Loading'

export default Loading

export { StyledLoading }
